import { useEffect } from 'react';
import { Logo } from '@/components/market-ui';
import { Card } from '@/components/ui/card';
import { LoginForm } from './login-form';

const SITE = 'https://www.moneyhq.in';

export function LoginPage() {
  useEffect(() => { document.title = 'Sign in · MoneyHQ'; }, []);
  return (
    <main className="grid min-h-screen place-items-center bg-[radial-gradient(1200px_600px_at_50%_-10%,var(--brand-soft),var(--tint)_60%,var(--background))] px-4 py-8">
      <div className="w-full max-w-[920px]">
        <Card className="grid gap-0 overflow-hidden p-0 shadow-[0_24px_60px_rgba(0,60,100,0.12)] md:grid-cols-[1fr_1fr]">
          <div className="px-7 py-9 sm:px-10">
            <a href={SITE} aria-label="MoneyHQ"><Logo size={32} /></a>
            <h1 className="mt-7 text-[28px] font-semibold">Sign in to MoneyHQ</h1>
            <p className="mt-1.5 mb-7 text-sm text-muted-foreground">Sign in with Google to start. New here? You get a full practice board right away; the live market opens once your access is approved.</p>
            <LoginForm />
          </div>
          <div className="relative hidden bg-ink md:block">
            {/* Photo: Adam Śmigielski on Unsplash (Unsplash License: free for commercial use). */}
            <img src="/login-panel.webp" alt="" className="absolute inset-0 h-full w-full object-cover" />
            <div className="absolute inset-0 bg-[linear-gradient(180deg,rgba(11,23,34,0.05)_30%,rgba(11,23,34,0.9)_100%)]" />
            <div className="absolute inset-x-0 bottom-0 p-8 text-white">
              <p className="font-heading text-[22px] leading-snug font-semibold">Sector flow, order blocks, sweeps and order flow, live.</p>
              <p className="mt-2 text-sm text-white/75">Every F&amp;O stock on one board, explained in plain English.</p>
            </div>
          </div>
        </Card>
        <p className="mt-5 text-center text-xs text-muted-foreground">
          By continuing you agree to the <a className="underline hover:text-ink" href={`${SITE}/terms/`}>Terms</a> and{' '}
          <a className="underline hover:text-ink" href={`${SITE}/privacy/`}>Privacy Policy</a>. For learning only, not investment advice.
        </p>
      </div>
    </main>
  );
}
